/*jshint esversion: 6 */
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import Translations from "@/js/translations.js";


window.intlTelInput = intlTelInput;

window.intlTelInputDefaults = {
    customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
        "use strict";
        selectedCountryPlaceholder = selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
        return selectedCountryPlaceholder;
    },
    i18n: Translations.intlPhoneInput,
    initialCountry: window.country,
    strictMode: true,
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/20.3.0/js/utils.js",
};

// Global (e não <script> inline no componente): componentes injetados via AJAX do Livewire
// (ex.: modais) não executam <script>, o que deixava window.phoneInput indefinido.
window.phoneInput = function ({livewireModel, initialValue, live = false}) {
    return {
        iti: null,
        init() {
            // Autofill do Chrome dispara keydown sem `key`, e o strictMode do intl-tel-input
            // lê e.key.length (TypeError). Engole esses eventos antes do handler da lib.
            this.$refs.input.addEventListener('keydown', (e) => {
                if (!e.key) e.stopImmediatePropagation();
            }, true);

            this.iti = window.intlTelInput(this.$refs.input, window.intlTelInputDefaults);

            if (livewireModel && this.$wire) {
                this.$nextTick(() => {
                    const lwValue = this.$wire.get(livewireModel);

                    if (lwValue) {
                        this.iti.setNumber(lwValue);
                        this.sync();
                    }
                });

                // Mantém sincronizado em updates
                window.Livewire.hook('commit', ({ succeed }) => {
                    succeed(() => {
                        const lwValue = this.$wire.get(livewireModel);
                        if (lwValue && this.iti.getNumber() !== lwValue) {
                            this.iti.setNumber(lwValue);
                            this.sync();
                        }
                    });
                });

                return;
            }

            if (initialValue) {
                this.iti.setNumber(initialValue);
                this.sync();
            }
        },

        sync() {
            // getNumber() volta "" enquanto o utils.js do intl-tel-input (carregado
            // de um CDN externo) ainda não terminou de carregar — sem isso o sync
            // grava telefone vazio no Livewire mesmo com o campo preenchido.
            this.iti.promise.then(() => {
                const number = this.iti.getNumber();
                // Campo realmente vazio (usuário apagou o número) é diferente de
                // getNumber() falhar por falta de utils.js: só nesse segundo caso
                // evitamos sobrescrever o valor já salvo.
                if (!number && this.$refs.input.value) return;

                this.$refs.hidden.value = number;
                if (livewireModel && this.$wire) {
                    this.$wire.set(livewireModel, number, live);
                }
            });
        }
    }
}
